import { useLocation, useParams } from 'react-router-dom';

export const useSimulationId = () => {
  const location = useLocation();
  const { id } = useParams();

  if (location.pathname.includes('simulation')) {
    return { id: Number(id) || 0 };
  } else {
    return { id: 0 };
  }
};
